import React from 'react';
import { sectionTitles } from '../data/themes';

const Topbar = ({ activeSection, dateString, onToggleSidebar }) => (
  <div className="topbar" data-testid="topbar">
    <div className="topbar-left">
      <button className="menu-toggle-btn" onClick={onToggleSidebar} data-testid="menu-toggle-btn">☰</button>
      <div className="topbar-title">{sectionTitles[activeSection]}</div>
    </div>
    <div className="topbar-right">
      <div className="topbar-badge" data-testid="topbar-date">📅 {dateString}</div>
    </div>
  </div>
);

export default Topbar;
